import { useEffect, useState } from "react";
import NumberStepper from "../../../../lib/inputs/NumberStepper";

interface FormNumberStepperWrapper {
    value: string
    label: string
    required: boolean
    onChange: Function,
    validateRule?: Function,
    validationError?: string
    autocomplete?: string
    name?: string
    inputType?: string
}

export default function FormNumberStepperWrapper({ value, label, required, onChange, validateRule, validationError, autocomplete, name, inputType }: FormNumberStepperWrapper) {

    const [currentError, setCurrentError] = useState<string | undefined | null>(undefined);

    function handleChange(val: number) {
        onChange(val)
        validate(val);
    }

    function validate(val: any) {
        if (!required && (val === undefined || val === null)) {
            setCurrentError(undefined);
            return null
        }

        if (validateRule) {
            const error = validateRule(val) ? null : validationError;
            setCurrentError(error);
            return error;
        }
    }

    return (
        <div>
            <NumberStepper
                inputClassName="number-stepper__number-input--white"
                value={value ? Number(value) : undefined}
                Label={label}
                OnChange={handleChange}
                required={required}
                step={1}
                min={0}
                autocomplete={autocomplete}
                name={name} />
                {currentError && <p className="error margin__top--xxs">{currentError}</p>}
        </div>
    )
}